import * as React from 'react';

function SvgSoccer(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg height="1em" viewBox="0 0 16 16" width="1em" {...props}>
			<path
				d="M8 0c4.41 0 8 3.59 8 8s-3.59 8-8 8-8-3.59-8-8 3.59-8 8-8zm1.768 11.5H6.235l-1.002 1.203.63 1.964a6.99 6.99 0 003.916.104l.974-2.105-.985-1.167zm3.374 1.245l-1.456.287-.572 1.237a7.036 7.036 0 002.028-1.524zm-8.5 1.396l-.343-1.07-1.19-.067c.456.445.971.828 1.533 1.137zm-1.914-7.3L1.033 8.683a6.962 6.962 0 001.193 3.27l2.228.121.98-1.177L4.27 7.594 2.728 6.84zm10.556 0l-1.54.754-1.177 3.301.967 1.146 2.498-.493a6.944 6.944 0 00.935-2.866L13.284 6.84zM8.008 5.424L5.268 7.42l1.086 3.08h3.293l1.1-3.08-2.74-1.996zM1.046 7.191l1.021-1.11-.282-1.3a6.937 6.937 0 00-.739 2.41zM14.224 4.8l-.278 1.284 1.007 1.098a6.944 6.944 0 00-.729-2.382zM10.57 1.49L8.508 2.6v1.95l2.885 2.104 1.572-.77.492-2.264a7.036 7.036 0 00-2.887-2.131zM2.555 3.606l.492 2.277 1.576.77L7.508 4.55V2.596L5.445 1.483a7.027 7.027 0 00-2.89 2.123zM8 1a6.99 6.99 0 00-1.165.097l1.175.635L9.184 1.1C8.799 1.034 8.404 1 8 1z"
				fill="#00182E"
				fillRule="evenodd"
			/>
		</svg>
	);
}

export default SvgSoccer;
